// extracted by mini-css-extract-plugin
export default {"avatarSelector":"AvatarSelector_avatarSelector__KM6FW","emptyAvatar":"AvatarSelector_emptyAvatar__E6gvY"};